var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 47,
    viewBox: "0 0 51 47",
    fill: "#3664A7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2747 10.9973H20.76C23.2845 10.9973 24.9969 13.5924 24.0083 15.9228L20.2303 24.7498C19.6654 26.0385 18.3943 26.8859 16.982 26.8859H6.53081C4.58886 26.8859 3 25.2971 3 23.3551V13.1334C3 12.1978 3.37073 11.2974 4.05924 10.6442L11.1209 3.58258C11.88 2.80581 13.1334 2.80581 13.9102 3.58258C14.3692 4.05924 14.581 4.7301 14.4398 5.3833L13.2747 10.9973ZM34.0355 19.8243H44.4867C46.4286 19.8243 48.0175 21.4131 47.9998 23.3551V33.5768C47.9998 34.5124 47.6291 35.3951 46.9583 36.066L39.8966 43.1276C39.1375 43.9044 37.8841 43.9044 37.1073 43.1276C36.6483 42.6509 36.4365 41.9801 36.5777 41.3269L37.7428 35.7129H30.2575C27.7154 35.7129 26.0206 33.1178 27.0092 30.7874L30.7872 21.9604C31.3521 20.6717 32.6232 19.8243 34.0355 19.8243Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbs);
export default __webpack_public_path__ + "static/media/thumbs.31bf7cf21bb4fa80833937e5744dabf6.svg";
export { ForwardRef as ReactComponent };